import { useTranslation } from 'react-i18next';
import { publicStatusURL } from '../../services/serviceAvailabilityService';

// Share the existing public-evidence precedence across startup and the banner.
// This selects presentation only; it never authorizes account access or requests.
export const availabilityTitle = value => value?.maintenance && !value.maintenance.stale
  ? 'availability.maintenance' : value?.offline ? 'availability.offline'
    : value?.available === false ? 'availability.unavailable'
      : value?.maintenance ? 'availability.lastReported' : null;

export function ServiceAvailabilityDetails({ maintenance, title }) {
  const { t, i18n } = useTranslation();
  if (!maintenance) return null;
  const language = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];
  const message = maintenance.message?.[language === 'zh' ? 'cn' : language];
  return <>
    <p className="text-sm">{maintenance.stale && title !== 'availability.lastReported' ? `${t('availability.lastReported')} ` : ''}{message || t('availability.maintenanceDetail')}</p>
    {maintenance.expectedRecoveryAt && <p className="text-sm">{t('availability.estimate', { time: new Date(maintenance.expectedRecoveryAt).toISOString().replace('T', ' ').replace('.000Z', ' UTC') })}</p>}
  </>;
}

export function ServiceAvailabilityStatusLink() {
  const { t } = useTranslation();
  const statusURL = publicStatusURL(import.meta.env.VITE_PUBLIC_STATUS_URL);
  return statusURL ? <a href={statusURL} target="_blank" rel="noreferrer" className="py-1.5 underline">{t('availability.statusLink')}</a> : null;
}
